/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offline_Banner_SetsInputs */

const en_us2_offline_banner_sets = /** @type {(inputs: Offline_Banner_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 set did not sync`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 set did not sync`);
	return /** @type {LocalizedString} */ (`${i?.count} sets did not sync`)
	
};

const pt_br2_offline_banner_sets = /** @type {(inputs: Offline_Banner_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série não sincronizou`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série não sincronizou`);
	return /** @type {LocalizedString} */ (`${i?.count} séries não sincronizaram`)
	
};

const es_419_offline_banner_sets = /** @type {(inputs: Offline_Banner_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie no se sincronizó`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 serie no se sincronizó`);
	return /** @type {LocalizedString} */ (`${i?.count} series no se sincronizaron`)
	
};

const pt_pt2_offline_banner_sets = /** @type {(inputs: Offline_Banner_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série não sincronizou`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série não sincronizou`);
	return /** @type {LocalizedString} */ (`${i?.count} séries não sincronizaram`)
	
};

const fr_fr2_offline_banner_sets = /** @type {(inputs: Offline_Banner_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série non synchronisée`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série non synchronisée`);
	return /** @type {LocalizedString} */ (`${i?.count} séries non synchronisées`)
	
};

const de_de2_offline_banner_sets = /** @type {(inputs: Offline_Banner_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Satz nicht synchronisiert`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Satz nicht synchronisiert`);
	return /** @type {LocalizedString} */ (`${i?.count} Sätze nicht synchronisiert`)
	
};

const it_it2_offline_banner_sets = /** @type {(inputs: Offline_Banner_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie non sincronizzata`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 serie non sincronizzata`);
	return /** @type {LocalizedString} */ (`${i?.count} serie non sincronizzate`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 set did not sync" |
* | "-1" | "1 set did not sync" |
* | * | "{count} sets did not sync" |
*
* @param {Offline_Banner_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_banner_sets = /** @type {((inputs: Offline_Banner_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Banner_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_banner_sets(inputs)
	if (locale === "es-419") return es_419_offline_banner_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_banner_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_banner_sets(inputs)
	if (locale === "de-DE") return de_de2_offline_banner_sets(inputs)
	if (locale === "it-IT") return it_it2_offline_banner_sets(inputs)
	return en_us2_offline_banner_sets(inputs)
});
export { offline_banner_sets as "offline.banner_sets" }